export const appGroupIdComparePreviewsAi = "/:app_group_id/compare_previews_ai";
